import createMap from './map'

import getBounds from './regions/bounds'
import addOverlay from './regions/overlay'
import addMarkers from './regions/markers'

import createIframe from './utils/iframe'

const regions = {
  CENTRUM: {
    fillColor: '#E40520',
    strokeColor: '#E40520',
    markerColor: '#E40520',
    locations: [{ lat: 52.22286645680418, lng: 6.901960450908269 }],
  },
  NOORD: {
    fillColor: '#3FA535',
    strokeColor: '#3FA535',
    markerColor: '#3FA535',
    locations: [{ lat: 52.2389749, lng: 6.8831326 }],
  },
  OOST: {
    fillColor: '#F9C600',
    strokeColor: '#F9C600',
    markerColor: '#F9C600',
    locations: [{ lat: 52.2178996, lng: 6.9247815 }],
  },
  WEST: {
    fillColor: '#009FE3',
    strokeColor: '#009FE3',
    markerColor: '#009FE3',
    locations: [{ lat: 52.2095352, lng: 6.8718441 }],
  },
  ZUID: {
    fillColor: '#532078',
    strokeColor: '#532078',
    markerColor: '#532078',
    locations: [
      { lat: 52.1918092, lng: 6.8804939 },
      { lat: 52.1940575, lng: 6.8752771 },
    ],
  },
}

const mapOptions = {
  styles: [
    { stylers: [{ visibility: 'simplified' }] },
    { elementType: 'labels', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels',
      stylers: [{ visibility: 'simplified' }],
    },
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    {
      featureType: 'road.arterial',
      stylers: [{ color: '#ff0000' }, { weight: 0.5 }],
    },
    { featureType: 'road.local', stylers: [{ color: '#cccccc' }] },
    {
      featureType: 'transit.line',
      elementType: 'geometry.fill',
      stylers: [{ color: '#7f7f7f' }],
    },
  ],
}

export default (container, DEBUG = false) => {
  /**
   * This code only works if the Google Maps API has loaded.
   */
  const iframe = createIframe(container)
  const bounds = getBounds()
  const map = createMap(iframe.contentDocument.body, bounds, mapOptions)
  const { overlay, handlers } = addOverlay(map, bounds, regions, DEBUG)
  const markers = addMarkers(map, regions, DEBUG)

  const showRegion = (key) => {
    overlay[key].show()
    markers[key].forEach((marker) => marker.setVisible(true))
  }

  const hideRegion = (key) => {
    overlay[key].hide()
    markers[key].forEach((marker) => marker.setVisible(false))
  }

  const focusRegion = (key) => {
    overlay[key].focus()
  }

  const blurRegion = (key) => {
    overlay[key].blur()
  }

  return {
    hideRegion,
    hideRegions: () => Object.keys(regions).forEach(hideRegion),
    showRegion,
    showRegions: () => Object.keys(regions).forEach(showRegion),
    focusRegion,
    focusRegions: () => Object.keys(regions).forEach(focusRegion),
    blurRegion,
    blurRegions: () => Object.keys(regions).forEach(blurRegion),

    handlers,
  }
}
